import { useEffect, useState } from 'react';

import { UserManagementServices } from 'admin/services';
import { IExpert, IPageResult } from 'common/models';

export const useExperts = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [queryOptions, setQueryOptions] = useState({});
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 15,
  });
  const [expertResults, setExpertResults] = useState<IPageResult<IExpert>>({
    data: [],
    total: 0,
  });

  useEffect(() => {
    const queryParams = new URLSearchParams({
      page: (paginationModel.page + 1).toString(),
      pageSize: paginationModel.pageSize.toString(),
      ...queryOptions,
    });
    setIsLoading(true);
    UserManagementServices.getExperts(queryParams.toString())
      .then((res) => setExpertResults(res))
      .catch((err) => console.error(err))
      .finally(() => setIsLoading(false));
  }, [paginationModel.page, paginationModel.pageSize, queryOptions]);

  return {
    expertResults,
    isLoadingExperts: isLoading,
    paginationModel,
    setPaginationModel,
    setQueryOptions,
  };
};
